import React, { useState, useEffect } from 'react';
import { withAuthorization } from '../Session';
import { withFirebase } from '../Firebase';
import { compose, setDisplayName } from 'recompose';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Input from '@material-ui/core/Input';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import Link from '@material-ui/core/Link';

import Copyright from '../Copyright';

import useStyles from '../../styles/styles';
import SuccessSnackbar from '../Snackbar/SnackbarSuccess';
import FailureSnackbar from '../Snackbar/SnackbarFailure';


const Clarifai = require('clarifai');

const app = new Clarifai.App({ 
  apiKey: process.env.REACT_APP_CLARIFAI_KEY
});

function ImageUpload({ firebase }) {

  const classes = useStyles();

  const allInputs = {imgUrl: ''}
  const [ imageAsFile, setImageAsFile] = useState('')
  const [ currentImage, setCurrentImage ] = useState('')
  const [ imageAsUrl, setImageAsUrl ] = useState(allInputs)
  const [ allImages, setAllImages ] = useState([])
  const [ error, setError ] = useState(null)
  const [ displayMessage, setDisplayMessage ] = useState('')
  const [ savedImages, setSavedImages ] = useState([]);
  const [ similarImages , setSimilarImages] = useState([]);



  useEffect(() => {
    firebase.getAllImages().then(urls => setAllImages(urls))
    .catch(err => setError(err));
  }, [ firebase.currentUser, firebase.getAllImages ])

  useEffect(
    () => {
      if(firebase.currentUser) {
        var user = firebase.currentUser;
        firebase.getSavedImages(user.uid).then((savedImages) => {
          setSavedImages(savedImages)
        })
      }
    }, [ firebase.currentUser, firebase.db ]
  )

  useEffect(
    () => {
      if(displayMessage)
      {
      setTimeout(() => setDisplayMessage(''), 1000)
      }
    }, [ displayMessage ]
  )

  const findSimilarImages = (image) => {
    app.models.initModel({id: Clarifai.GENERAL_MODEL, version: "aa7f35c01e0642fda5cf400f543e7c40"})
      .then(generalModel => {
        return generalModel.predict(image);
      })
      .then(response => {
        var concepts = response['outputs'][0]['data']['concepts']
        let similarImageArray = [];
        concepts.map(element => similarImageArray.push((element.name)));
        setSimilarImages(similarImageArray);
      })
      }
  
  const handleImageAsFile = (e) => {
    const image = e.target.files[0]
    setCurrentImage(URL.createObjectURL(image))
    setImageAsFile(image);
  }

  const handleFireBaseUpload = e => {
    e.preventDefault()
 
    if(imageAsFile === '') {
      console.error(`not an image, the image file is a ${typeof(imageAsFile)}`)
    }

  
  const uploadTask = firebase.uploadImage(imageAsFile)
    uploadTask.on('state_changed', 
    (snapShot) => {
      console.log(snapShot)
    }, (err) => {
      console.log(err)
    }, () => {
      setDisplayMessage('upload')
      firebase.getDownloadUrl(imageAsFile)
      .then(fireBaseUrl => {
        setImageAsUrl(prevObject => ({...prevObject, imgUrl: fireBaseUrl}))
      })
      .catch(err => setError(err))
    })
  }

  const saveToAlbum = (image) => {

    if(!savedImages.includes(image)) {
      const newImages = [...savedImages, image]
      firebase.saveImages(firebase.currentUser.uid, newImages).then(
        () => setSavedImages(newImages)
      )
      setDisplayMessage('saved')

    }

    if(savedImages.includes(image)) {
      setDisplayMessage('duplicate')
    }
  }

  const deleteImage = (URL) => {
    let object = firebase.getRefFromUrl(URL)
    firebase.deleteImage(object)
    setDisplayMessage('deleted')
  }


    return (
      <React.Fragment>
          <CssBaseline />
          <main>
            {/* Hero unit */}
            <div className={classes.heroContent}>
              <Container maxWidth="sm">
                <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                 Upload Image
                </Typography>
                <Typography variant="h5" align="center" color="textSecondary" paragraph>
                  Find similar images to your uploaded image
                </Typography>
                <form onSubmit={handleFireBaseUpload}>
                  <Input type="file" fullWidth onChange={handleImageAsFile}/>
                  <Card container spacing={2}>
                  { (currentImage !== '' ? 
                      <Card className={classes.card}>
                        <CardMedia
                          className={classes.cardMedia}
                          image={currentImage}
                        />
                        <CardActions>
                           <Button type="submit" size="small" color="secondary">
                              Upload
                          </Button>
                        </CardActions>
                      </Card>
                  : console.log('error'))
                  }   
               
                  {displayMessage === 'upload' && <SuccessSnackbar message={'Uploaded to Storage'} />}
                  {displayMessage === 'saved' && <SuccessSnackbar message={'Saved'} />}
                  {displayMessage === 'duplicate' && <FailureSnackbar message={'Already in Album'} />}
                  {displayMessage === 'deleted' && <FailureSnackbar message={'Image Deleted'} />}


                </Card>
                </form>   
              </Container>
            </div>
            <Container className={classes.cardGrid}  maxWidth="sm">
                  <Typography variant="h4" align="center" color="textPrimary" gutterBottom >
                    { (similarImages.length > 0 ? <p>Tags</p> : <p></p>)}
                  </Typography>  
                    <Grid container spacing={2}>
                    { (similarImages.length > 0 ? similarImages.map(item => (
                      <Grid item key={item} xs={12} sm={6} md={4}>
                      <Typography component="h5" variant="h5" align="center" color="textPrimary" gutterBottom>
                        <Link href={`/?q=${item}`} color="primary">{item}</Link>
                      </Typography>
                      </Grid>
                    ))  : console.log('No tags'))
                  }
                  </Grid>
             </Container>
              <Container className={classes.cardGrid}  maxWidth="md">
                  <Typography variant="h5" align="center" color="textSecondary" paragraph >
                     Uploaded Images
                  </Typography>
                <Grid container spacing={4}>
                { (allImages.length > 0 ? allImages.map(image => (
                  <Grid item xs={12} sm={6} md={4}>
                    <Card className={classes.card}>
                      <CardMedia
                        className={classes.cardMedia}
                        image={image}
                      />
                      <CardActions>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            startIcon={<SaveIcon />}
                            onClick={() => saveToAlbum(image) }
                          >
                            Save
                          </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.button}
                          startIcon={<DeleteIcon />}
                          onClick={() => deleteImage(image)}
                          >
                            Delete
                        </Button>
                        <Button color="primary" variant="outlined" onClick={() => findSimilarImages(image)}>
                            Tags
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))  : console.log('no images'))
              }
              </Grid>
              </Container>
           
          </main>
          {/* Footer */}
          <footer className={classes.footer}>
            <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
              Machine Learning Image Search
            </Typography>
            <Copyright />
          </footer>
          {/* End footer */}
        </React.Fragment>
  );
}

const condition = authUser => !!authUser;

const ImageUploadPage = compose(
  withAuthorization(condition),
  withFirebase,
)(ImageUpload)

export default ImageUploadPage;